'use strict';

module.exports = /*@ngInject*/ ["$scope", "$timeout", "$uibModalInstance", "markupPageSource", "AuthenticationFactory", "ProjectService", function ($scope, $timeout, $uibModalInstance, markupPageSource, AuthenticationFactory, ProjectService) {
    $scope.error = "";

    $scope.markupPageSource = "rest/static/doc/?documentationFile=" + angular.copy(markupPageSource.file) + "&projectId=" + ProjectService.getSelectedProjectId();
}];
